import { UiImageSetModel } from "../../models";

import { mockUiImageModel } from ".";

export function mockUiImageSetModel({
    id = "image-set-1234",
    type = "uiImageSet",
    locale = "en",
    content = mockUiImageSetModelContent()
}: Partial<UiImageSetModel> = {}): UiImageSetModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiImageSetModelContent = UiImageSetModel["content"];

export function mockUiImageSetModelContent({
    entryTitle = "image set",
    images = [mockUiImageModel(), mockUiImageModel(), mockUiImageModel()],
    ...optionals
}: Partial<UiImageSetModelContent> = {}): UiImageSetModelContent {
    return {
        entryTitle,
        images,
        ...optionals
    };
}
